import { render, staticRenderFns } from "./TwoStep.vue?vue&type=template&id=b04f7e4e&scoped=true&"
import script from "./TwoStep.vue?vue&type=script&lang=js&"
export * from "./TwoStep.vue?vue&type=script&lang=js&"
import style0 from "./TwoStep.vue?vue&type=style&index=0&id=b04f7e4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04f7e4e",
  null
  
)

export default component.exports